'use strict';

var reactHref = require('./reactHref.directive.js');

function register(angular) {
  var app = angular.module('angular.a', []);

  app.directive('reactHref', reactHref(angular));

  return 'angular.a';
}

module.exports = register;
